module.exports = __webpack_public_path__ + "img/gb1338.prt.854af61a.jpg";